import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    data: Array
  }

  connect() {
    console.log("Employee Loans Chart Controller connected")
    console.log("Data:", this.dataValue)
    
    // Check if Chart.js is loaded
    if (typeof Chart === 'undefined') {
      console.error("Chart.js is not loaded!")
      return
    }
    
    if (this.hasDataValue && this.dataValue.length > 0) {
      // Add a small delay to ensure DOM is ready
      setTimeout(() => this.initializeChart(), 300)
    } else {
      console.error("Missing or empty chart data")
    }
  }

  initializeChart() {
    const ctx = document.getElementById('employeeLoansChart')
    if (!ctx) {
      console.error("Canvas element not found")
      return
    }
    
    const data = this.dataValue
    const labels = data.map(item => item.name)
    const values = data.map(item => item.amount)
    const backgroundColors = this.generateColors(data.length)
    
    console.log("Creating chart with data:", { labels, values })
    
    try {
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{
            label: 'Préstamos por Empleado',
            data: values,
            backgroundColor: 'rgba(69, 123, 157, 0.7)',
            borderColor: 'rgba(69, 123, 157, 1)',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.raw
                  return new Intl.NumberFormat('es-CO', { 
                    style: 'currency', 
                    currency: 'COP',
                    maximumFractionDigits: 0
                  }).format(value)
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function(value) {
                  return new Intl.NumberFormat('es-CO', { 
                    style: 'currency', 
                    currency: 'COP',
                    notation: 'compact',
                    maximumFractionDigits: 0
                  }).format(value)
                }
              }
            }
          }
        }
      })
      console.log("Chart created successfully")
    } catch (error) {
      console.error("Error creating chart:", error)
    }
  }

  generateColors(count) {
    const colors = [
      'rgba(69, 123, 157, 0.7)',
      'rgba(191, 23, 36, 0.7)',
      'rgba(101, 109, 127, 0.7)',
      'rgba(191, 191, 193, 0.7)',
      'rgba(229, 229, 229, 0.7)',
      'rgba(69, 123, 157, 0.5)',
      'rgba(191, 23, 36, 0.5)',
      'rgba(101, 109, 127, 0.5)',
      'rgba(191, 191, 193, 0.5)',
      'rgba(229, 229, 229, 0.5)'
    ]
    
    // If we need more colors than we have, we'll generate them
    if (count > colors.length) {
      for (let i = colors.length; i < count; i++) {
        const r = Math.floor(Math.random() * 255)
        const g = Math.floor(Math.random() * 255)
        const b = Math.floor(Math.random() * 255)
        colors.push(`rgba(${r}, ${g}, ${b}, 0.7)`)
      }
    }
    
    return colors.slice(0, count)
  }
}
